const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDoorWhite0 = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    "data-name": "Livello 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 567.81 1079.25",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "g980"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path982",
    d: "M512.67,55.39,567.9.15V1079.39H512.67V55.39",
    transform: "translate(-0.1 -0.15)",
    style: {
      fill: "#edeef0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g984"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path986",
    d: "M.1.15,55.33,55.39v1024H.1V.15",
    transform: "translate(-0.1 -0.15)",
    style: {
      fill: "#edeef0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g988"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path990",
    d: "M50.1,50.18l5.22,5.23v1024H50.1V50.18",
    transform: "translate(-0.1 -0.15)",
    style: {
      fill: "#c5c6c7"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g992"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path994",
    d: "M.1.15,5.32,5.38v1074H.1V.15",
    transform: "translate(-0.1 -0.15)",
    style: {
      fill: "#f7f6f6"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g996"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path998",
    d: "M567.9.15l-5.22,5.23v1074h5.22V.15",
    transform: "translate(-0.1 -0.15)",
    style: {
      fill: "#c5c6c7"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1000"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1002",
    d: "M517.88,50.18l-5.23,5.23v1024h5.23V50.18",
    transform: "translate(-0.1 -0.15)",
    style: {
      fill: "#f7f6f6"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1004"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1006",
    d: "M55.33,55.39.1.15H567.9L512.67,55.39H55.33",
    transform: "translate(-0.1 -0.15)",
    style: {
      fill: "#edeef0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1008"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1010",
    d: "M50.1,50.18H517.88l-5.23,5.23H55.32L50.1,50.18",
    transform: "translate(-0.1 -0.15)",
    style: {
      fill: "#a8a9aa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1012"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1014",
    d: "M.1.15H567.9l-5.22,5.23H5.32L.1.15",
    transform: "translate(-0.1 -0.15)",
    style: {
      fill: "#faf9f9"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1016"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1018",
    d: "M512.66,1079.4H55.33V55.4H512.66v1024",
    transform: "translate(-0.1 -0.15)",
    style: {
      fill: "#89898a"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1020"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1022",
    d: "M60.67,1079.39V60.72H507.34V1079.39H60.67",
    transform: "translate(-0.1 -0.15)",
    style: {
      fill: "#edeef0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "path1036",
    d: "M108.28,585.49H74.77V549.31h33.51v36.18",
    transform: "translate(-0.1 -0.15)",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1038",
    d: "M108.28,585.49H91.53V549.31h16.75v36.18",
    transform: "translate(-0.1 -0.15)",
    style: {
      fill: "#757575"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1040",
    d: "M103.85,581.05H79.21v-27.3h24.64v27.3",
    transform: "translate(-0.1 -0.15)",
    style: {
      fill: "#ababab"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1042",
    d: "M74.77,549.31l4.44,4.44h24.64l4.43-4.44H74.77",
    transform: "translate(-0.1 -0.15)",
    style: {
      fill: "#d6d6d6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1044",
    d: "M74.77,585.49l4.44-4.44h24.64l4.43,4.44H74.77",
    transform: "translate(-0.1 -0.15)",
    style: {
      fill: "#595959"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1046",
    d: "M172.26,568.94c-29.92.87-59.6,4.48-89.5,5.36V562.13c29.9-.88,59.58-4.48,89.5-5.36v12.17",
    transform: "translate(-0.1 -0.15)",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1048",
    d: "M172.26,568.94c-24.78.71-49.36,3.24-74.09,4.93V561.7c24.73-1.69,49.31-4.23,74.09-4.93v12.17",
    transform: "translate(-0.1 -0.15)",
    style: {
      fill: "#757575"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1050",
    d: "M169.16,565.86c-27.83,1-55.47,4.28-83.31,5.32v-6c27.84-1,55.48-4.28,83.31-5.32v6",
    transform: "translate(-0.1 -0.15)",
    style: {
      fill: "#ababab"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1052",
    d: "M82.76,562.13l3.09,3.08c27.84-1,55.48-4.28,83.31-5.32,1.24-1.26,1.86-1.88,3.1-3.12-29.92.88-59.6,4.48-89.5,5.36",
    transform: "translate(-0.1 -0.15)",
    style: {
      fill: "#d6d6d6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1054",
    d: "M82.76,574.3c1.24-1.24,1.85-1.87,3.09-3.12,27.84-1,55.48-4.28,83.31-5.32l3.1,3.08c-29.92.87-59.6,4.48-89.5,5.36",
    transform: "translate(-0.1 -0.15)",
    style: {
      fill: "#595959"
    }
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDoorWhite0);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/door-white0.628698098e98286f86ef2d5349cbfa34.svg";